import { gridSizeMdLg6, } from "@/shared";
import { useFetchCanalesVenta } from "@/shared/actions/erp";
import { useFetchConfigComisionById, useFetchPostConfigComision, useFetchPutConfigComision } from "@/shared/actions/erp/comision/configuracion-comision.actions";
import { useFetchEmpleados } from "@/shared/actions/erp/empleados";
import { CustomAutocomplete, CustomNumberTextField, SampleDatePicker, SingleFormBoxScene, SwitchComponenteForm } from "@/shared/components/ui";
import { CanalVenta } from "@/shared/interfaces";
import { IConfigComisionesData } from "@/shared/interfaces/erp/comision/comision.interface";
import { Empleado } from "@/shared/interfaces/erp/empleados";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";


export default function ComisionPageCreateOrEdit() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [esEditar, setEsEditar] = useState(false);
  const [canalVenta, setCanalVenta] = useState<string | null>(null);
  ///* form
  const form = useForm<IConfigComisionesData>({
    //resolver: yupResolver(newZoneSchema),
  });
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = form;

  const { data: canalesVentaRes, isLoading: isLoadingCanalesVenta } =
    useFetchCanalesVenta({
      page_size: 1000,
    });

  const { data: dataUser, isLoading: isLoadingUser } =
    useFetchEmpleados({
      enabled: true,
      params: {
        canal_venta: canalVenta!,
        page_size: 1000,
      }
    });

  const fetchPostConfigComision = useFetchPostConfigComision();
  const fetchPutConfigComision = useFetchPutConfigComision();

  const { data: dataConfigComision, isLoading: isLoadingConfigComision } = useFetchConfigComisionById(id!);

  const OnchangeCanalVenta = (value: string) => {
    form.getValues().canal_venta = value;
    setCanalVenta(value);
  }

  useEffect(() => {
    if (!isLoadingConfigComision) {
      if (dataConfigComision) {
        setEsEditar(true);
        reset(dataConfigComision);
      }
    }


  }, [dataConfigComision, isLoadingConfigComision])


  return (
    <SingleFormBoxScene
      titlePage={'Configuración Comisión'}
      saveTextBtn={esEditar ? 'Actualizar' : 'Guardar'}
      onCancel={() => {
        navigate('/parametrizacion/comicion-configuracion')
      }}
      onSave={handleSubmit(async (e) => {
        let resp = null;
        if (esEditar) {
          resp = await fetchPutConfigComision.mutateAsync(e);
        } else {
          resp = await fetchPostConfigComision.mutateAsync(e);
        }
        if (resp.code == 200) navigate('/parametrizacion/comicion-configuracion')
      })}

    >
      <Grid container spacing={3}>
        <CustomNumberTextField
          control={control}
          name={"valor_base"}
          min={0}
          step={0.01}
          defaultValue={form.getValues().valor_base || ''}
          size={gridSizeMdLg6}
          label={'Valor Base'}
          error={errors.valor_base}
          helperText={errors.valor_base?.message} />

        <CustomNumberTextField
          control={control}
          name={"porcentaje"}
          min={0}
          step={0.01}
          defaultValue={form.getValues().porcentaje || ''}
          size={gridSizeMdLg6}
          label={'Porcentaje'}
          error={errors.porcentaje}
          helperText={errors.porcentaje?.message} />

        <SampleDatePicker
          label="Fecha Inicio"
          control={control}
          error={errors.fecha_inicio}
          helperText={errors.fecha_inicio?.message}
          name="fecha_inicio"
          textFieldKey="fecha_inicio"
          size={gridSizeMdLg6}
          defaultValue={new Date().toISOString().split("T")[0]}
        />

        <SampleDatePicker
          label="Fecha Final"
          control={control}
          error={errors.fecha_final}
          helperText={errors.fecha_final?.message}
          name="fecha_final"
          textFieldKey="fecha_final"
          size={gridSizeMdLg6}
          defaultValue={new Date().toISOString().split("T")[0]}
        />
        <CustomAutocomplete<CanalVenta>
          label="Canal Venta"
          name="canal_venta"
          options={canalesVentaRes?.data?.data || []}
          valueKey="nombre" // name is the fk
          actualValueKey="codigo"
          defaultValue={form.getValues().canal_venta }
          isLoadingData={isLoadingCanalesVenta}
          control={form.control}
          error={errors.canal_venta}
          helperText={errors.canal_venta?.message}
          size={gridSizeMdLg6}
          onChangeValue={OnchangeCanalVenta}
        />
        {canalVenta && (
          <CustomAutocomplete<Empleado>
            label="Supervisor de Venta"
            name="supervisor_venta"
            options={dataUser?.data?.data || []}
            valueKey="razon_social"
            actualValueKey="codigo"
            defaultValue={form.getValues().supervisor_venta}
            isLoadingData={isLoadingUser}
            control={form.control}
            error={errors.supervisor_venta}
            helperText={errors.supervisor_venta?.message}
            size={gridSizeMdLg6}
          />
        )}


        <SwitchComponenteForm
          control={control}
          defaultValue={false}
          label="Estado"
          name="estado"
          onChangeValue={() => { }}
          size={gridSizeMdLg6}
        />


      </Grid>



    </SingleFormBoxScene>
  );

}
